<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// This is a new Question and only for Call Survey
export default defineComponent({
  name: 'SurveyQ3',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('survey_03_checkbox_4'), key: '5' },
        { text: this.$t('survey_03_checkbox_3'), key: '4' },
        { text: this.$t('survey_03_checkbox_2'), key: '3' },
        { text: this.$t('survey_03_checkbox_1'), key: '2' },
        { text: this.$t('survey_03_checkbox_0'), key: '1' }
      ]
    };
  },
  computed: {
    ...mapGetters(['continueSupportService'])
  },
  methods: {
    ...mapActions(['changeContinueSupportService']),

    change (event: number) {
      this.changeContinueSupportService(Number(event));
    },
    nextScreen () {
      if (this.continueSupportService >= 3) {
        // If the user selects 3 or more, go to question 4
        router.push({ path: '/survey/question4SSC/' });
      } else {
        router.push({ path: '/survey/question5Faq/' });
      }
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ $t('survey_03_01') }}</p>
      <radio-button :text="data" @change="change($event)" :value="continueSupportService.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!continueSupportService"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
